import { useEffect, useState, type CSSProperties } from 'react';
import { ArrowUp } from 'lucide-react';

export function BackToTop() {
  const [{ visible, footerLift }, setPosition] = useState({ visible: false, footerLift: 0 });

  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      const footer = document.querySelector<HTMLElement>('.site-footer');
      const next = {
        visible: window.scrollY > 500,
        footerLift: footer ? Math.max(0, Math.ceil(window.innerHeight - footer.getBoundingClientRect().top)) : 0,
      };
      setPosition(current => current.visible === next.visible && current.footerLift === next.footerLift ? current : next);
    };
    const scheduleUpdate = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('resize', scheduleUpdate);
    };
  }, []);

  if (!visible) return null;

  return (
    <button
      className="back-to-top"
      type="button"
      aria-label="Back to top"
      title="Back to top"
      style={{ '--back-to-top-lift': `${footerLift}px` } as CSSProperties}
      onClick={() => {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
      }}
    >
      <ArrowUp size={16} strokeWidth={1.8} aria-hidden="true" />
      <span>Back to top</span>
    </button>
  );
}
